import React from 'react';
const bonuses = [{
  id: 1,
  title: 'BONO 1: Mapa Anual de Derecho',
  description: 'Todo el año de Derecho ordenado en un vistazo. Secuencia lógica, qué dar primero y qué después.',
  image: 'https://cdn.magicpatterns.com/uploads/4Z46DNJUxNEgqLDbsFhgow/BONO_1_DERECHO.png'
}, {
  id: 2,
  title: 'BONO 2: Evaluaciones Prácticas',
  description: 'Evaluar sin improvisar. Consignas listas, casos simples y claros. Ideal para TP y trabajos grupales.',
  image: 'https://cdn.magicpatterns.com/uploads/hDeNrtJdXfFfh4YHuKKj6G/BONO_2_DERECHO.png'
}, {
  id: 3,
  title: 'BONO 3: Casos Reales',
  description: 'El Derecho que sí se entiende. Situaciones cotidianas y preguntas para debatir conceptos jurídicos.',
  image: 'https://cdn.magicpatterns.com/uploads/rc1fD6EFt4RmC9DFpwLTwu/BONO_3_DERECHO.png'
}];
export function BonusSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-20 bg-blue-900 text-white overflow-hidden" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="text-center mb-10 md:mb-16" data-id="element-3">
          <span className="inline-block px-4 py-1 bg-amber-500 text-slate-900 font-bold rounded-full text-sm mb-4 animate-pulse" data-id="element-4">
            GRATIS POR HOY
          </span>
          <h2 className="text-2xl md:text-4xl font-bold mb-3 text-amber-400" data-id="element-5">
            Llevate estos 3 REGALOS Exclusivos
          </h2>
          <p className="text-amber-100 max-w-2xl mx-auto text-sm md:text-base" data-id="element-6">
            Complementos perfectos para potenciar tus clases y ahorrar aún más
            tiempo.
          </p>
        </div>

        {/* Mobile: horizontal scroll row / Desktop: 3-col grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-7">
          {bonuses.map(bonus => <div key={bonus.id} className="group cursor-pointer" onClick={scrollToPricing} data-id="element-8">
              <div className="relative mb-6 transform transition-transform duration-300 group-hover:scale-105" data-id="element-9">
                <div className="absolute inset-0 bg-amber-500/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-10"></div>
                <img src={bonus.image} alt={bonus.title} className="w-full relative z-10 drop-shadow-2xl" data-id="element-11" />
              </div>
              <div className="text-center" data-id="element-12">
                <h3 className="text-xl font-bold text-amber-400 mb-2" data-id="element-13">
                  {bonus.title}
                </h3>
                <p className="text-amber-100 text-sm leading-relaxed" data-id="element-14">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* Mobile: compact card layout */}
        <div className="md:hidden space-y-4 max-w-sm mx-auto" data-id="element-15">
          {bonuses.map(bonus => <div key={bonus.id} className="flex items-center gap-4 bg-blue-800/50 rounded-xl p-3 border border-blue-700/50 cursor-pointer" onClick={scrollToPricing} data-id="element-16">
              <img src={bonus.image} alt={bonus.title} className="w-20 h-20 object-contain flex-shrink-0 drop-shadow-lg" data-id="element-17" />
              <div data-id="element-18">
                <h3 className="text-sm font-bold text-amber-400 mb-1" data-id="element-19">
                  {bonus.title}
                </h3>
                <p className="text-amber-100 text-xs leading-relaxed" data-id="element-20">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}